<template>
  <v-row v-if="module" class="m-0 module-header-container">
    <v-row class="m-0">
      <div class="titre-module col-9 px-0" v-html="titleHtml"></div>
      <div class="col px-0" v-if="module.add">
        <a class="section-add" @click="addItem">+ {{ module.add.label }}</a>
      </div>
    </v-row>
  </v-row>
</template>

<script lang="ts">
import Module from '@/generated/classes/Module';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  props: {
    module: {
      type: Object as PropType<Module>,
      required: true
    }
  },
  computed: {
    titleHtml(): string {
      return this.module.label;
    }
  },
  methods: {
    addItem(): void {
      this.$emit('addItem', this.module);
    }
  }
})
</script>

<style>
.module-header-container {
  padding: 0px 24px 0px 20px !important;
}
</style>